import { useQuery } from "@tanstack/react-query";
import instance from "../instance";

export const useFetchDashboard = (filters) => {
    const getDashboardData=async()=>{
const {data}= await instance.get(`/api/shopper/dashboard?projectId=${filters?.projectId}`)
return data    
}
    const query = useQuery({queryKey:['dashboard', filters], queryFn: getDashboardData});
return query
}